import { Spacer, Text } from '@oy/uidesktop';
import { SystemIcon } from '@oy/uiicon';
import { useTranslate } from 'src/hooks';
import { ErrorBoundary } from '../../../ErrorBoundary';
import styles from '../Sidebar.module.css';
import { BankAccountTooltip } from './BankAccountTooltip/BankAccountTooltip';
import { useBankAccountSectionImpl } from './useBankAccountSectionImpl';

export const BankAccountSection = () => {
  const { data, isSidebarCollapsed, color, showTooltip, setShowTooltip } =
    useBankAccountSectionImpl();
  const { getTranslation } = useTranslate();
  return (
    <Spacer bottom={Spacer.Size.XL}>
      <Text
        textStyle={Text.Style.BodySmRegular}
        color={color}
        className={styles.balanceLabel}
      >
        {getTranslation('overbooking_yourAccount')}
      </Text>
      <span
        role="button"
        id="menuDetailBalance"
        className={styles.balanceButton}
      >
        {!isSidebarCollapsed && (
          <>
            <Text textStyle={Text.Style.HeadingSm} color={color}>
              {data.accountNumber}
            </Text>
            <SystemIcon name="arrow-down" size={16} color={color} />
          </>
        )}
      </span>
      <ErrorBoundary domain="dashboard" componentName="BalanceTooltip">
        <BankAccountTooltip
          bankName={data.bankName}
          accountNumber={data.accountNumber}
          setShowTooltip={setShowTooltip}
          showTooltip={showTooltip}
        />
      </ErrorBoundary>
    </Spacer>
  );
};
